// 产品参考模型库。length 是场景显示尺寸，不代表真实物理尺寸。
import { modelCatalog, getUploadedModel } from '../api/modelCatalog'
import deviceCatalog from './deviceCatalog.json'

export const NODE_MODEL_LIBRARY = {
  router: [
    { id: 'router_edge', name: '边缘路由器', length: 38 },
    { id: 'router_tower', name: '塔式路由器', length: 42 },
    { id: 'router_rack', name: '机架路由器', length: 44 },
    { id: 'router_portable', name: '便携路由器', length: 34 },
    { id: 'access_point', name: '吸顶无线接入点', length: 32, specialized: true }
  ],
  switch: [
    { id: 'switch_rack', name: '机架交换机', length: 44 },
    { id: 'switch_desktop', name: '桌面交换机', length: 32 },
    { id: 'switch_uplink', name: '汇聚交换机', length: 40 }
  ],
  station: [
    { id: 'station_mast', name: '桅杆基站', length: 46 },
    { id: 'station_pole', name: '杆式基站', length: 42 },
    { id: 'station_tripod', name: '三脚架基站', length: 38 }
  ],
  satellite: [
    { id: 'satellite_cube', name: '立方卫星', length: 40 },
    { id: 'satellite_comms', name: '通信卫星', length: 42 },
    { id: 'satellite_relay', name: '中继卫星', length: 46 }
  ],
  drone: [
    { id: 'drone_quad', name: '四旋翼', length: 38 },
    { id: 'drone_hexa', name: '六旋翼', length: 42 },
    { id: 'drone_fixed_wing', name: '固定翼', length: 44 }
  ],
  terminal: [
    { id: 'terminal_laptop', name: '移动终端', length: 34 },
    { id: 'terminal_rugged', name: '加固终端', length: 32 },
    { id: 'terminal_dual', name: '双屏终端', length: 42 },
    { id: 'ugv_patrol', name: '四轮巡检无人车', length: 42, specialized: true },
    { id: 'smartphone', name: '智能手机', length: 30, specialized: true }
  ],
  gateway: [
    { id: 'gateway_rack', name: '机架网关', length: 44 },
    { id: 'gateway_compact', name: '紧凑网关', length: 38 },
    { id: 'gateway_industrial', name: '工业网关', length: 34 },
    { id: 'firewall_appliance', name: '机架式防火墙', length: 42, specialized: true }
  ],
  service: [
    { id: 'service_blade', name: '刀片服务节点', length: 38 },
    { id: 'service_node', name: '机架服务节点', length: 40 },
    { id: 'service_micro', name: '微型服务集群', length: 32 }
  ],
  storage: [
    { id: 'storage_rack', name: '机架存储', length: 44 },
    { id: 'storage_array', name: '塔式阵列', length: 40 },
    { id: 'storage_nas', name: '桌面网络存储', length: 36 }
  ],
  controller: [
    { id: 'controller_rack', name: '机架控制器', length: 42 },
    { id: 'controller_console', name: '控制台', length: 34 },
    { id: 'controller_handheld', name: '手持控制器', length: 30 }
  ],
  sensor: [
    { id: 'sensor_weather', name: '气象传感器', length: 42 },
    { id: 'sensor_environment', name: '环境传感器', length: 34 },
    { id: 'sensor_lidar', name: '激光雷达', length: 38 },
    { id: 'network_camera', name: '网络监控摄像头', length: 34, specialized: true }
  ],
  actuator: [
    { id: 'actuator_linear', name: '直线执行器', length: 40 },
    { id: 'actuator_rotary', name: '旋转执行器', length: 36 },
    { id: 'actuator_pneumatic', name: '气动执行器', length: 44 },
    { id: 'robot_dog', name: '四足巡检无人狗', length: 38, specialized: true }
  ]
}

// Preserve asset IDs and order so saved topologies keep their selected device.
NODE_MODEL_LIBRARY.switch.push({ id: 'tplink_sg108', length: 32, specialized: true })
NODE_MODEL_LIBRARY.router.push({ id: 'ubiquiti_u6_plus', length: 32, specialized: true })
NODE_MODEL_LIBRARY.router.push({ id: 'mikrotik_rb5009', length: 36, specialized: true })
NODE_MODEL_LIBRARY.switch.push({ id: 'unifi_flex_mini', length: 30, specialized: true })
NODE_MODEL_LIBRARY.storage.push({ id: 'synology_ds224', length: 34, specialized: true })
NODE_MODEL_LIBRARY.storage.push({ id: 'synology_ds1522', length: 40, specialized: true })
NODE_MODEL_LIBRARY.service.push({ id: 'raspberry_pi5', length: 32, specialized: true })
NODE_MODEL_LIBRARY.service.push({ id: 'jetson_orin_nano', length: 36, specialized: true })
NODE_MODEL_LIBRARY.sensor.push({ id: 'axis_m3065', length: 32, specialized: true })
NODE_MODEL_LIBRARY.sensor.push({ id: 'livox_mid360', length: 30, specialized: true })
NODE_MODEL_LIBRARY.router.push({ id: 'unifi_u6_mesh', length: 36, specialized: true })
NODE_MODEL_LIBRARY.gateway.push({ id: 'teltonika_rutx11', length: 36, specialized: true })
NODE_MODEL_LIBRARY.terminal.push({ id: 'yealink_t54w', length: 36, specialized: true })
NODE_MODEL_LIBRARY.terminal.push({ id: 'zebra_zd421', length: 36, specialized: true })
NODE_MODEL_LIBRARY.sensor.push({ id: 'realsense_d435i', length: 32, specialized: true })
NODE_MODEL_LIBRARY.actuator.push({ id: 'ur5e', length: 44, specialized: true })
for (const models of Object.values(NODE_MODEL_LIBRARY)) {
  for (const model of models) Object.assign(model, deviceCatalog[model.id])
}

// Version both library previews and topology assets to invalidate old GLB caches.
export const builtinModelPath = (id) => `models/blender/${id}.glb?v=product-catalog-20260925`

export const NODE_MODEL_ASSETS = Object.fromEntries(
  Object.entries(NODE_MODEL_LIBRARY).map(([category, models]) => [
    category,
    models.map(({ id }) => id)
  ])
)

export function getNodeModelOptions(category) {
  return [...(NODE_MODEL_LIBRARY[category] || []), ...modelCatalog.models.filter((model) => model.category === category || model.category === 'generic')].map((model) => ({
    ...model,
    parameters: model.parameters || []
  }))
}

function hashSeed(value) {
  let hash = 2166136261
  const text = String(value)
  for (let index = 0; index < text.length; index++) {
    hash ^= text.charCodeAt(index)
    hash = Math.imul(hash, 16777619)
  }
  return hash >>> 0
}

// 兼容旧拓扑：没有 modelId 时仍按节点 id 稳定选择；一旦用户在面板中
// 应用型号，modelId 会写回拓扑并成为后续渲染的唯一依据。
export function nodeModelVariantIndex(category, seed, modelId) {
  const models = NODE_MODEL_LIBRARY[category] || []
  if (!models.length) return 0
  const explicit = models.findIndex(({ id }) => id === modelId)
  if (explicit >= 0) return explicit
  return hashSeed(`${category}:${seed}`) % models.filter(model => !model.specialized).length
}

export function getNodeModelSpec(category, modelId, seed = '') {
  const models = getNodeModelOptions(category)
  if (!models.length || modelId === 'default') return null
  if (modelId && !models.some(model => model.id === modelId)) return null
  return models.find((model) => model.id === modelId) || models[nodeModelVariantIndex(category, seed, modelId)]
}


// 业务分类不能保证外观匹配；未收录设备使用统一的通用图形。
export function resolveNodeModelCategory(node) {
  const category = node.category
  const uploaded = getUploadedModel(node.modelId)
  if (uploaded && (uploaded.category === category || uploaded.category === 'generic')) return category || 'generic'
  if (node.modelId === 'default' || !NODE_MODEL_LIBRARY[category]) return 'generic'
  if (node.modelId && NODE_MODEL_LIBRARY[category].some(({ id }) => id === node.modelId)) return category
  const identity = [node.id, node.label, node.meta?.['设备类型'], node.meta?.deviceType, node.meta?.type].filter(Boolean).join(' ')
  if (/无人车|无人狗|机器狗|四足机器人|地面无人|robot[ _-]?dog|quadruped|unmanned[ _-]?(ground|vehicle)|(?:^|[^a-z])(?:ugv|dog)\d*(?=$|[^a-z])/i.test(identity)) return 'generic'
  if (node.modelId && !NODE_MODEL_LIBRARY[category].some(({ id }) => id === node.modelId)) return 'generic'
  return category
}
